type RankedFeature = { properties?: { rank?: number } };

export const nwsAlertFeatureComparator = (
  a: RankedFeature,
  b: RankedFeature,
): number => (a.properties?.rank ?? 0) - (b.properties?.rank ?? 0);

export const sortByRank = <T extends RankedFeature>(features: T[]): T[] =>
  [...features].sort(nwsAlertFeatureComparator);
